import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import {handleLogout} from "../Utils/auth";
import API from '../Utils/api'
import {getUsuarioFromStorage} from "../Utils/usuarioHelper";
import DetalhamentoPedido from "../_Components/DetalhamentoPedido";
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class BilhetesMaster extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
        this.state = {
            pedidos: [],
            user: JSON.parse(localStorage.getItem("user")),
            clienteSelecionado: null,
            pedidoSelecionado: null,
            searched: [],
            cartelas: [],
            code: ''
        };
        // this.listarPedidos();
        this.selecionarPedido = this.selecionarPedido.bind(this)
        this.deselecionarPedido = this.deselecionarPedido.bind(this)
        this.getPedidoPorTransacao = this.getPedidoPorTransacao.bind(this)
    }
    
    handlerCode(e){
        this.setState({code : e.target.value})
    }
    deselecionarPedido(event) {
        this.setState({pedidoSelecionado: null, clienteSelecionado: null})
        this.forceUpdate()
    }

    selecionarPedido(event) {
        if(event.target.accessKey){
        const pedido = JSON.parse(event.target.accessKey)
        this.setState({pedidoSelecionado: event.target.accessKey, clienteSelecionado: JSON.stringify(pedido.clienteId)})
        this.forceUpdate()
        }
    }


    formatDate(data) {
    return moment(data).add(0,'days').format('DD-MM-YYYY')
    }
    

    listarPedidos = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("pedidos/listar", {});
            this.setState({pedidos: response.data.reverse(), searched: response.data.reverse()});
            this.contarCartelas()
        } catch (err) {
            console.log(err);
        }
    };

    async getPedidoPorTransacao(e) {
        try {
            const response = await API.post("/api/pedidos/por-transacao", {
                transacaoId: e._id
            });
            return response.data
        } catch (err) {
            console.log(err);
        }
    };

    async searchCode(){
        if(this.state.code == ''){
            alert("Porfavor, insira algum codigo")
            return;
        }
        try {
            const response= await API.post("/api/pedidos/search-any-code", {
                code: this.state.code
            });
            this.setState({searched : response.data})
        } catch (err) {
            console.log(err);
        }
        

    }


    async deletarPedido(e){
        var pedido = JSON.parse(e.target.accessKey)
        try {
            const response1 = await API.post("/api/pedidos/deleta", {
                id: pedido._id
            });
            const response2 = await API.post("/api/transacoes/deleta", {
                id: pedido.transacaoId._id
            });

            if(response1.data && response2.data ){
                window.location.reload()
            }
        } catch (err) {
            console.log(err);
        }
    }

     editarPedido(e){
        localStorage.setItem("pedido", e.target.accessKey);
        this.props.history.push('/editar-pedido')
    }

    contarCartelas(){
        var cartelas = []
        this.state.pedidos.forEach(pedido => {
            pedido.cartelas.forEach(cartela => {
                cartelas.push(cartela)
            })
        })
        this.setState({cartelas: cartelas})
    }

    contarCartelas(){
    var cartelas = []
    this.state.pedidos.forEach(pedido => {
        pedido.cartelas.forEach(cartela => {
            cartelas.push(cartela)
        })
    })
    this.setState({cartelas: cartelas})
}
    

    render() {
        return (
            <MasterTemplate label={'Cartelas'}>
                <div onClick={this.deselecionarPedido} class="modal fade" id="exampleModalCenter" tabIndex="-1"
                     role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{maxWidth: '95vw', marginTop: '-8em'}}
                         role="document">
                        <div class="modal-content ">
                            <div class="modal-header">
                                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento
                                    pedido</h4>
                                <button onClick={this.deselecionarPedido} type="button" class="close"
                                        data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                {this.state.pedidoSelecionado && this.state.clienteSelecionado ? <DetalhamentoPedido user={this.state.clienteSelecionado}
                                                                                    pedido={this.state.pedidoSelecionado}/> : ""}
                            </div>
                            <div class="modal-footer" style={{justifyContent: 'flex-end'}}>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Acompanhe pedidos em tempo real
                                    </h4>
                                    <p className="card-category">Informações de pedidos.</p>
                                     <p className="card-category">Numero de cartelas : {this.state.cartelas.length}</p>
                                </div>
                                <div className="row mt-3 pl-5 pr-5">
                                        <input id="codigo" class="ml-5 form-control" style={{maxWidth: '80%'}} type="search" placeholder="código do pedido ou código da cartela" onChange={this.handlerCode.bind(this)}  aria-label="Search" />
                                        <button  onClick={this.searchCode.bind(this)}  className="ml-1 btn-fill btn btn-danger ">BUSCAR</button>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Codigo</th>
                                            <th>Cliente</th>
                                            <th>Vendedor</th>
                                            <th>Qtd de cartelas</th>
                                            <th>Valor total</th>
                                            <th>BTN</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.pedidos != null
                                            ? Object.entries(this.state.searched).map(
                                                (item, index) => {
                                                    return (
                                                        <tr
                                                            style={{cursor: 'pointer'}}
                                                            accessKey={JSON.stringify(item[1])}
                                                            data-toggle="modal"
                                                            data-target="#exampleModalCenter"
                                                            onClick={this.selecionarPedido}
                                                        >
                                                            <td accessKey={JSON.stringify(item[1])}>{this.formatDate(item[1].data)}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].codigo}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].clienteId ? item[1].clienteId.nome : "Desconhecido"}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].cambistaId ? item[1].cambistaId.nome : "Desconhecido"}</td>
                                                            
                                                            <td accessKey={JSON.stringify(item[1])}
                                                                className="pl-5">{item[1].cartelas ? item[1].cartelas.length : "0"}</td>
                                                            <td accessKey={JSON.stringify(item[1])}
                                                                className="pl-5">{item[1].cartelas[0] ? (item[1].cartelas.length * item[1].cartelas[0].valor).toFixed(2) : "0"}</td>
                                                            <td>

                                                            <div class="btn-group" role="group" accessKey={JSON.stringify(item[1])}>
                                                                <button id="btnGroupDrop1" accessKey={JSON.stringify(item[1])} type="button" style={{border: 'none'}} class="color-dark font-weight-bold btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <span className="font-weight-bold color-dark" >...</span> 
                                                                </button>
                                                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" accessKey={JSON.stringify(item[1])}>
                                                                <Link class="dropdown-item"  accessKey={JSON.stringify(item[1])} onClick={this.editarPedido.bind(this)} >Editar</Link>
                                                                <Link class="dropdown-item" accessKey={JSON.stringify(item[1])} onClick={this.deletarPedido.bind(this)}>Deletar</Link>
                                                                </div>
                                                            </div>

                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )
                                            : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default BilhetesMaster;
